export default __webpack_public_path__ + "static/media/trend02.4d266868.png";